import en from './errors.en';

const ru = {
    subTitle: 'Неизвестная ошибка',
    title: 'Упс! Что-то пошло не так',
    description: 'Наши программисты уже ищут неисправность. Как только мы ее устраним, сайт заработает в нормальном режиме.',
};

export default { ru, en: { ...ru, ...en} };
